import { Component, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { FormGroup, FormBuilder, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Country, LookupData } from 'src/app/shared/models/lookup-data.model';
import { ApplicationService } from 'src/app/shared/services/application.service';
import { SingleResultApiResponse } from 'src/app/shared/models/api-response.model';
import { AustralianStates } from '../address/address.model';
import { ParentAddress, ParentAddressErrors, ParentAddressConfig } 
from '../../models/parent-guardian-details';
import { slideInOut } from '../../animations/slideInOut';
import { AddressService } from '../../../shared/services/address.service';
@Component({
  selector: 'online-app-parent-address',
  templateUrl: './parent-address.component.html',
  styleUrls: ['./parent-address.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ParentAddressComponent),
    multi: true
  }],
  animations: [slideInOut]
})
export class ParentAddressComponent implements OnInit {

  @Input() data: ParentAddress;
  @Input() errors: ParentAddressErrors;
  @Input() config: ParentAddressConfig;
  @Output() countryChanged = new EventEmitter();
  parentAddressFormGroup: FormGroup;

  gender: string = '';
  countries: Country[];
  isAustralianAddress: boolean = false;
  applicationId: number;
  isSubmittedApplication: boolean;
  australianStates: any[];

  selectedCountry: LookupData;
  selectedAustralianState: LookupData;

  australiaCountryId: string = '';


  private _value: ParentAddress = {   
    IsAustralianAddress: undefined,
    AddressLine1: undefined,
    AddressLine2: undefined,
    SuburbTownCity: undefined,
    StateProvinceRegion: undefined,
    Postcode: undefined,
    CountryId: undefined
  }

  constructor(private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private addressService: AddressService,
    private applicationService: ApplicationService) {
      this.activatedRoute.parent.parent.params.subscribe(params =>{
        this.applicationId = +params['id'];
      });
      this.selectedAustralianState = this.getDefaultAustralianState();
     }

  ngOnInit() {
    const countries = this.activatedRoute.snapshot.data['countries'];
    this.countries = [this.getDefaultCountry(), ...countries];

    this.australiaCountryId = this.countries.filter(c => c.Code === "AU")[0].Id;
    //console.log("Austrlia country Id in db is:", this.australiaCountryId);


    this.parentAddressFormGroup = this.formBuilder.group({

    });

    this.applicationService.getApplicationDetails(this.applicationId)
    .subscribe( (response: SingleResultApiResponse) => {
      if (response.Result) {

        this.isSubmittedApplication = response.Result.ApplicationStatus === 'Submitted';

        if (this.isSubmittedApplication) {
          this.parentAddressFormGroup.disable();

        }
      }
      }, err => {
          console.error(err);
      });

      this.australianStates = [this.getDefaultAustralianState(), ...AustralianStates ] ;

    //console.log("===CURRENT ADDRESS DATA passing from parent-Control is:", this.data);

    //trick to wait this child-component fully loaded
    window.setTimeout(() => {
      if (this.data.IsAustralianAddress) {        
        this.value.CountryId = this.australiaCountryId;

        this.value.IsAustralianAddress = true;
        this.isAustralianAddress = true;

        this.countryChanged.emit(this.isAustralianAddress);
        this.addressService.loadAddressWidget('AuAddressLine1', this, this.setAddressPart);
      }

      //console.log("----parent address error input passing to is:--->", this.errors);
      //console.log("---this.value.CountryId (Aus or overseas) is:--", this.value.CountryId);
    });

  }
  private setAddressPart(container, line1Ctl,  line1: string, suburb: string, state: string, postcode: string) {
    setTimeout(() => {
      container._value.AddressLine1 = line1;
      container._updateValue(line1, 'AddressLine1');
      line1Ctl.blur();
    }, 10);
    container._value.AddressLine2 = '';
    container._value.SuburbTownCity = suburb;
    container._value.StateProvinceRegion = state;
    container._value.Postcode = postcode;
    if (container.errors) {
      container.errors.AddressLine1 = '';
      container.errors.AddressLine2 = '';
      container.errors.SuburbTownCity = '';
      container.errors.StateProvinceRegion = '';
      container.errors.Postcode = '';
    }
  }
  private _onChange = (_: any) => {};
  private _onTouched = (_: any) => {};

  set value(value: ParentAddress) {
    this._value = value;
    this._onChange(this._value);
  }

  get value() {
    return this._value;
  }

  writeValue(value: ParentAddress): void {
    if (value && value !== null) {
      this._value = value;
    }
  }
  registerOnChange(fn: (_: any) => void): void {
    this._onChange = fn;
  }
  registerOnTouched(fn: (_: any) => void): void {
    this._onTouched = fn;
  }

  private _updateValue(value: any, field: string) {
    const newValue = this._value;
    newValue[field] = value;
    this.value = newValue;
    //console.log('updated value');
    //console.log(newValue);
  }
  
  countryUpdate(countryId: any) {
    //console.log(countryId);
    this._updateValue(countryId, 'CountryId');

    //this.errors.CountryId = '';
    if (countryId.toLowerCase() == this.australiaCountryId.toLowerCase()){
      this.isAustralianAddress = true;
      this.addressService.loadAddressWidget('AuAddressLine1', this, this.setAddressPart);
    } else {
      this.isAustralianAddress = false;
    }

    this.countryChanged.emit(this.isAustralianAddress);
  }

  line1Update(event: any) {
    this._updateValue(event.target.value, 'AddressLine1');
    //this.errors.AddressLine1 = '';
  }
  line2Update(event: any) {
    this._updateValue(event.target.value, 'AddressLine2');
    //this.errors.AddressLine2 = '';
  }
  suburbUpdate(event: any) {
    this._updateValue(event.target.value, 'SuburbTownCity');
    //this.errors.SuburbTownCity = '';
  }
  stateInputUpdate(event: any) {
    this._updateValue(event.target.value, 'StateProvinceRegion');
    //this.errors.StateProvinceRegion = '';
  }
  stateUpdate(code: any) {
    this._updateValue(code, 'StateProvinceRegion');
    //this.errors.StateProvinceRegion = '';
  }
  postcodeUpdate(event: any) {
    this._updateValue(event.target.value, 'Postcode');
    //this.errors.Postcode = '';
  }

  getDefaultCountry(): Country {
    return {
      Id: '',
      Code: '',
      Description: 'Please select Country',
      Status: '',
      IsAgentMandatory: false,
      CanStudyAbroad: false,
      PhoneCode: 0,
      IsDeleted: false
    };
  }
  getDefaultAustralianState(): LookupData  {
    return {
      Code: '',
      Description: 'Please select',
    };
  }

  countryCodeDescription(country: Country) {
    const selectedCountry = this.countries.find(c => c.Code === country.Code);
    if (selectedCountry && selectedCountry.Code.length > 0) {
      return `${selectedCountry.Description} (+${selectedCountry.PhoneCode})`;
    }
    return 'Country code';
  }
  getPostcodeText(): string {
    return this.isAustralianAddress ? 'Postcode' : 'Postcode/Zipcode';
  }

}
